const state = {
    itens: [],
    item: {
        client: {
            id: null,
            name: 'Não definido',
            cpf_cnpj: '',
            registration_number: '',
            dispatcher_registration_number: '',
            shipment_date_registration_number: new Date(),
            date_of_birth: new Date(),
            nationality: '',
            profession: '',
            marital_status: 'S',
            sex: 'M',
            authorize_disseminate_data: false,
            mail: null,
            cell_phone: null
        },
        client_address: {
            cep: '',
            address: '',
            number: '',
            borough: '',
            complement: '',
            city: {
                id: null,
                name: 'Não definido',
                state: {
                    id: null,
                    name: 'Não definido',
                    abbreviation: 'ND'
                }
            }
        },
        after_sale_remarkers: [],
        created_at: new Date(),
        group: null,
        physical_proposal: null,
        representative: {
            id: null,
            name: 'Não definido'
        },
        representative_id: null,
        quota: null,
        situation: 'N',
        after_sale_status: {
            id: null,
            status: 'Não definido'
        }
    }
};

export default state;